import { toString, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { React_withKeyAuto_2B31D457 } from "../UI.js";
import { singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Icon } from "@iconify/react/dist/offline";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";

export class Rotate extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Deg90", "Deg180", "Deg270"];
    }
}

export function Rotate_$reflection() {
    return union_type("Shopfoo.Client.Components.Icon.Rotate", [], Rotate, () => [[], [], []]);
}

export class IconProp extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["IconifyIcon", "HFlip", "VFlip", "Rotate", "Size"];
    }
}

export function IconProp_$reflection() {
    return union_type("Shopfoo.Client.Components.Icon.IconProp", [], IconProp, () => [[["Item", class_type("Glutinum.Iconify.IconifyIcon", undefined, IconifyIcon)]], [], [], [["Item", Rotate_$reflection()]], [["Item", class_type("Feliz.Styles.ICssUnit")]]]);
}

/**
 * Helper to create an icon component with the given <c>props</c>.
 */
export function iconCustom(props) {
    let properties;
    return React_withKeyAuto_2B31D457((properties = toList(delay(() => collect((prop) => {
        const matchValue = prop;
        return (matchValue.tag === 1) ? singleton(["hFlip", true]) : ((matchValue.tag === 2) ? singleton(["vFlip", true]) : ((matchValue.tag === 3) ? ((matchValue.fields[0].tag === 1) ? singleton(["rotate", "deg180"]) : ((matchValue.fields[0].tag === 2) ? singleton(["rotate", "deg270"]) : singleton(["rotate", "deg90"]))) : ((matchValue.tag === 4) ? singleton(["width", toString(matchValue.fields[0])]) : singleton(["icon", matchValue.fields[0]]))));
    }, props))), reactApi.createElement(Icon, createObj(properties))));
}

/**
 * Helper to create an icon component with the given <c>iconifyIcon</c>.
 */
export function icon(iconifyIcon) {
    return iconCustom(singleton_1(new IconProp(0, [iconifyIcon])));
}

